import React from 'react';
import { useStyletron } from 'baseui';
import type { RelationshipT } from '../../../../../modernization-common/relationships';
import { ActionSection } from './action-section';
import { RelationshipSelector } from './relationship-selector';
import { SameInterval } from './same-interval';
import { SourceSection } from './source-section';
import { TargetsListWrapper } from './targets-list-wrapper';
type RelationshipEditorPanelProps = {
  onSave: (relationships: RelationshipT[]) => void;
  onCancel: () => void;
  isVideoTask: boolean;
};
export const RelationshipEditorPanel = ({
  onSave,
  onCancel,
  isVideoTask
}: RelationshipEditorPanelProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    height: '100%'
  })}>
      <div className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.sizing.scale600,
      flex: 1,
      padding: `0 ${theme.sizing.scale600}`
    })}>
        <SourceSection />
        <RelationshipSelector isVideoTask={isVideoTask} />
        {isVideoTask && <SameInterval />}
        <hr className={css({
        width: '100%',
        height: '1px',
        border: 'none',
        backgroundColor: theme.colors.borderOpaque,
        margin: `${theme.sizing.scale200} 0`
      })} />
        <TargetsListWrapper isVideoTask={isVideoTask} />
      </div>

      <div className={css({
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.sizing.scale400,
      padding: `${theme.sizing.scale400} ${theme.sizing.scale600}`,
      borderTop: `1px solid ${theme.colors.borderOpaque}`,
      position: 'sticky',
      bottom: 0,
      backgroundColor: theme.colors.backgroundPrimary
    })}>
        <ActionSection onSave={onSave} onCancel={onCancel} />
      </div>
    </div>;
};